<template>
  <div>
    <div class="coupon-base">
      <h3>优惠券基本信息</h3>
      <el-form
        ref="couponFormRef"
        :model="couponInfo"
        :inline="true"
        :rules="couponInfoRules"
        v-loading="formLoading"
      >
        <el-row>
          <el-col :span="10" :offset="2">
            <el-form-item label="优惠券名称:" prop="title">
              <el-input v-model="couponInfo.title"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="2">
            <el-form-item label="优惠券类型:" prop="type">
              <el-select v-model="couponInfo.type">
                <el-option
                  v-for="item in couponTypeOptions"
                  :key="Number(item.value)"
                  :label="item.label"
                  :value="Number(item.value)"
                  default-first-option
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="2">
            <el-form-item label="领取方式:" prop="receiveType">
              <el-select v-model="couponInfo.receiveType">
                <el-option
                  v-for="item in couponReceiveTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <!--说明-->
              <div class="explain">
                系统赠送: 相关活动赠送
                <br />
                新用户注册: 会员注册后,自动赠送
                <br />
                用户推广: 会员推广成功后(新用户注册),自动赠送
                <br />
                优惠券兑换: 相关优惠Code兑换
                <br />
                用户领取: 用户主动领取
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="2">
            <el-form-item label="有效期类型:" prop="validityType">
              <el-select v-model="couponInfo.validityType">
                <el-option
                  v-for="item in couponValidityTypeOptions"
                  :key="Number(item.value)"
                  :label="item.label"
                  :value="Number(item.value)"
                ></el-option>
              </el-select>
              <div class="explain">
                固定时: 优惠券Code与当前有效期保持一致
                <br />
                领取后N天有效: 优惠券Code在领取后N天后有效
                <br />
                长期有效: 优惠券Code永久有效
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="2">
            <el-form-item label="消费方式:" prop="consumeType">
              <el-select v-model="couponInfo.consumeType">
                <el-option
                  v-for="item in couponConsumeTypeOptions"
                  :key="Number(item.value)"
                  :label="item.label"
                  :value="Number(item.value)"
                ></el-option>
              </el-select>
              <!--说明-->

              <div class="explain">
                线上核销: 指用户在下单时使用优惠券进行线上核销
                <br />
                线下核销
                指用户到店后，出示二维码或者出示串码，由收银员完成核销动作，如扫码核销、机具核销等。
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="2">
            <el-form-item label="优惠券面额:" prop="amount">
              <el-input-number
                v-model="couponInfo.amount"
                :precision="2"
                :min="0"
                controls-position="right"
              ></el-input-number>
              <!--说明-->
              <div class="explain">
                满减券: 订单金额满足最低消费，则为减免金额。
                <br />
                代金券: 直接为减免金额
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="2">
            <el-form-item label="优惠券折扣:">
              <el-input-number
                v-model="couponInfo.discount"
                :precision="2"
                :max="1"
                :min="0"
                controls-position="right"
              ></el-input-number>
              <!--说明-->
              <div class="explain">
                折扣券: 0.8=8折,计算方式: 订单总额*折扣 100*(1-0.8)
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="2">
            <el-form-item label="券折扣上限:">
              <el-input-number
                v-model="couponInfo.discountLimit"
                :precision="2"
                :min="-1"
                controls-position="right"
              ></el-input-number>
              <!--说明-->
              <div class="explain">
                表示最多允许折扣多少,与`优惠券折扣`相关，如果不填或者小于等于零，则默认为无限制
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="2">
            <el-form-item label="最低消费:">
              <el-input-number
                v-model="couponInfo.minCost"
                :precision="2"
                :min="0"
                controls-position="right"
              ></el-input-number>
              <!--说明-->
              <div class="explain">
                只有金额满足最低消费才能使用
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="2">
            <el-form-item label="有效期天数:">
              <el-input-number
                v-model="couponInfo.fixedTerm"
                :min="0"
                controls-position="right"
              ></el-input-number>
              <!--说明-->
              <div class="explain">
                N天失效 = 领取时间+有效期天数
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="2">
            <el-form-item label="优惠券总量:">
              <el-input-number
                v-model="couponInfo.total"
                :min="-1"
                controls-position="right"
              ></el-input-number>
              <!--说明-->
              <div class="explain">
                如果不填或者小于等于零，则默认为无限制
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="2">
            <el-form-item label="每人限领/张:" prop="maxFetch">
              <el-input-number
                v-model="couponInfo.maxFetch"
                :min="-1"
                controls-position="right"
              ></el-input-number>
              <!--说明-->
              <div class="explain">
                如果不填或者小于等于零，则默认为无限制
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="2">
            <el-form-item label="有效期开始时间:" prop="startTime">
              <el-date-picker
                v-model="couponInfo.startTime"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="2">
            <el-form-item label="有效期结束时间:" prop="endTime">
              <!--只允许明天之后-->
              <el-date-picker
                v-model="couponInfo.endTime"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="2">
            <el-form-item label="优惠券状态:" prop="status">
              <el-select v-model="couponInfo.status">
                <el-option
                  v-for="item in couponStatusOptions"
                  :key="Number(item.value)"
                  :label="item.label"
                  :value="Number(item.value)"
                >
                </el-option>
              </el-select>
              <div class="explain">
                将配合JOB进行启动与结束
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="优惠券介绍:">
              <div id="editor"></div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="button">
        <el-button type="primary" @click="handlerSave">保存</el-button>
      </div>
    </div>
    <div class="coupon-list">
      <div class="coupon-goods">
        <h3>参与商品</h3>
        <coupon-goods :coupon-id="couponInfo.id"></coupon-goods>
      </div>
      <div class="coupon-goods">
        <h3>参与型号</h3>
        <coupon-model :coupon-id="couponInfo.id"></coupon-model>
      </div>
      <div class="coupon-goods">
        <h3>参与品牌</h3>
        <coupon-brand :coupon-id="couponInfo.id"></coupon-brand>
      </div>
      <div class="coupon-goods">
        <h3>参与品类</h3>
        <coupon-category :coupon-id="couponInfo.id"></coupon-category>
      </div>
    </div>
  </div>
</template>
<script>
import {
  couponStatusApi,
  couponTypeApi,
  couponValidityApi,
  couponReceiveTypeApi,
  couponConsumeTypeApi,
  getCouponInfoApi,
  saveCouponInfoApi
} from "@/api/coupon";
import E from "wangeditor";
import couponGoods from "./couponGoods";
import couponModel from "./couponModel";
import couponBrand from "./couponBrand";
import couponCategory from "./couponCategory";
export default {
  name: "couponEdit",
  components: { couponGoods, couponModel, couponBrand, couponCategory },
  data() {
    return {
      formLoading: false,
      editor: undefined,
      couponId: undefined,
      couponInfo: {
        status: 0
      },
      couponInfoRules: {
        title: [{ required: true, message: "优惠券名称", trigger: "blur" }],
        type: [
          { required: true, message: "请选择优惠券类型", trigger: "change" }
        ],
        receiveType: [
          { required: true, message: "请选择是否主动领取", trigger: "change" }
        ],
        validityType: [
          { required: true, message: "请选择有效期类型", trigger: "change" }
        ],
        status: [
          { required: true, message: "请选择优惠券状态", trigger: "change" }
        ],
        startTime: [
          { required: true, message: "请选择有效期开始时间", trigger: "blur" }
        ]
        // endTime: [
        //   // 不允许与开始时间相同
        //   {
        //     validator: (rule, value, callback) => {
        //       if (
        //         value &&
        //         value.getTime() < this.couponInfo.startTime.getTime()
        //       ) {
        //         callback(new Error("结束时间必须大于开始时间"));
        //       } else {
        //         callback();
        //       }
        //     }
        //   }
        // ]
      },
      // 优惠券状态
      couponStatusOptions: [],
      // 优惠券类型
      couponTypeOptions: [],
      // 优惠券领取方式
      couponReceiveTypeOptions: [],
      // 优惠券有效期类型
      couponValidityTypeOptions: [],
      // 优惠券消费方式
      couponConsumeTypeOptions: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    };
  },
  created() {
    this.getBizCouponTypeOptions();
    this.getBizCouponValidityTypeOptions();
    this.getBizCouponReceiveTypeOptions();
    this.getBizCouponStatusOptions();
    this.getBizCouponConsumeTypeOptions();
  },
  mounted() {
    this.couponId = this.$route.query.id;
    this.createEditor();
  },
  watch: {
    "$route.query.id": {
      immediate: true,
      handler(nv, ov) {
        if (nv) {
          this.couponId = this.$route.query.id;
          this.getCouponInfo();
        } else {
          this.couponInfo = {
            minCost: 0,
            total: -1,
            status: 0,
            maxFetch: 1
          };
          this.editor.txt.html("");
        }
      }
    }
  },
  methods: {
    createEditor() {
      if (this.editor) {
        this.editor.destroy();
      }
      this.editor = new E("#editor");
      console.log(this.editor);
      this.editor.config.zIndex = 0;
      this.editor.create();
    },
    getCouponInfo() {
      let _self = this;
      getCouponInfoApi(this.couponId).then(res => {
        if (res.data.status == 100) {
          _self.setFormInfo(res.data.results);
        }
      });
    },
    setFormInfo(data) {
      this.couponInfo = data;
      if (this.editor) {
        this.editor.txt.html(data.descriptionHtml);
      }
    },
    getBizCouponTypeOptions() {
      let _self = this;
      couponTypeApi().then(resp => {
        if (resp.data.status == 100) {
          _self.couponTypeOptions = resp.data.results;
        }
      });
    },
    getBizCouponValidityTypeOptions() {
      let _self = this;
      couponValidityApi().then(resp => {
        if (resp.data.status == 100) {
          _self.couponValidityTypeOptions = resp.data.results;
        }
      });
    },
    getBizCouponReceiveTypeOptions() {
      let _self = this;
      couponReceiveTypeApi().then(resp => {
        if (resp.data.status == 100) {
          _self.couponReceiveTypeOptions = resp.data.results;
        }
      });
    },
    getBizCouponStatusOptions() {
      let _self = this;
      couponStatusApi().then(resp => {
        if (resp.data.status == 100) {
          _self.couponStatusOptions = resp.data.results;
        }
      });
    },
    getBizCouponConsumeTypeOptions() {
      let _self = this;
      couponConsumeTypeApi().then(resp => {
        if (resp.data.status == 100) {
          _self.couponConsumeTypeOptions = resp.data.results;
        }
      });
    },
    handlerSave() {
      this.$refs.couponFormRef.validate(valid => {
        console.log(valid);
        if (valid) {
          this.saveData();
        }
      });
    },
    getFormData() {
      const data = this.couponInfo;
      data.description = this.editor.txt.text();
      data.descriptionHtml = this.editor.txt.html();
      return data;
    },
    saveData() {
      let _self = this;
      const data = this.getFormData();
      this.formLoading = true;
      saveCouponInfoApi(data)
        .then(res => {
          console.log(res);
          if (res.data.status == 100) {
            _self.$message({
              message: res.data.message,
              type: "success"
            });
            _self.setFormInfo(res.data.results);
          } else {
            _self.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          _self.formLoading = false;
        });
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="scss" type="text/css" scoped>
.coupon-base {
  .button {
    display: flex;
    justify-content: center;
    button {
      width: 300px;
    }
  }
  .explain {
    font-size: 12px;
    color: #999;
    margin-top: 10px;
    line-height: 1.5;
  }
}
.coupon-list {
  margin-top: 30px;
  .coupon-goods {
    margin: 30px 0 30px 0;
  }
}
</style>



// WEBPACK FOOTER //
// couponEdit.vue?1189b8ec